if(!customElements.get('collection-grid')) {
  class CollectionGrid extends HTMLElement {
    constructor() {
      super();
      this.gridLoad = this.querySelector('.js-grid-load');
      this.loadMore = this.querySelector('.js-load-more');
      this.loadingBar = this.querySelector('.js-loading-bar');
      this.gridInner = this.querySelector('.js-grid-inner');
      this.gridWidth = this.gridInner?.clientWidth;
      this.filters = this.querySelector('.js-collection-filters');
      this.activeFilters = this.querySelector('.js-active-filters');
      this.filterBlocks = this.querySelectorAll('.js-filter-block');
        this.view = this.dataset.search ? 'ajax-search' : 'ajax-collection';
        this.pressArrowUpDown();
    }

      //Collection Banner
      pressArrowUpDown() {
        window.addEventListener('DOMContentLoaded', (event) => {
            document.querySelectorAll(".arrow-down").forEach(el => {
                el.addEventListener('click', function (e) {
                    if (this.classList.contains("arrow-down")) {
                        document.getElementById("text_truncat").style.display = 'none';
                        document.getElementById("text_full").style.display = 'block';
                        document.querySelector(".collection__inner").classList.toggle('flex-end');
                        this.classList.remove("arrow-down");
                        this.classList.toggle('arrow-up');
                    }
                    else {
                        document.getElementById("text_truncat").style.display = 'block';
                        document.getElementById("text_full").style.display = 'none';
                        document.querySelector(".collection__inner").classList.remove('flex-end');
                        this.classList.remove("arrow-up");
                        this.classList.toggle('arrow-down');
                    }
                });
            });
        });
      }

    /**
     * setupLoadingBar - Initializes the loading bar element text values and styles
     */

    setupLoadingBar() {
      this.loadingBar = this.querySelector('.js-loading-bar');
      if(!this.loadingBar) return;

      this.productsPerPage = Number(this.gridLoad.dataset.productsPerPage);
      this.currentPage = Number(this.gridLoad.dataset.currentPage);
      this.totalItems = Number(this.gridLoad.dataset.totalItems);

      if(this.productsPerPage && this.currentPage && this.totalItems) {
        this.loadingBar.style.width = `${((this.productsPerPage * this.currentPage) / this.totalItems * 100)}%` ;
      }
    }

    /**
     * initLoadMoreButton - Initializes the loading bar - load more button
     */

    initLoadMoreButton() {
      this.loadMoreButton = this.querySelector('.js-load-more');
      
      if(!this.loadMoreButton || !this.productsPerPage || !this.currentPage || !this.totalItems) return;

      this.loadMoreButton.addEventListener('click', (event) => {
        event.preventDefault();
        const params = new URLSearchParams(window.location.search);
        console.log("params",params)
        this.loadMoreButton = this.querySelector('.reedem-collection');
        if(this.loadMoreButton){
          params.set('view', 'rajax-all-products');
        }else{
          params.set('view', 'ajax-all-products');
        }
        const newSearch = params.toString();

        fetch(window.location.origin + window.location.pathname + '?' + newSearch)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser().parseFromString(html, 'text/html');
            const start = this.productsPerPage * this.currentPage;
            const end = this.productsPerPage * (this.currentPage + 1);
            const items = parser.querySelectorAll('[data-grid-index]');
            let hasLoadingButton = false;

            items.forEach((item, index) => {
              if(item.dataset.gridIndex > start && item.dataset.gridIndex <= end) {
                this.gridInner.appendChild(item);
              }

              if(item.dataset.gridIndex > end) {
                hasLoadingButton = true;

                return;
              };
            });

            if(hasLoadingButton && this.gridLoad) {
              this.gridLoad.setAttribute('data-current-page', this.currentPage + 1);
              this.gridLoad.querySelector('.js-currently-products').innerHTML = end;

              this.setupLoadingBar();
              var api = new Yotpo.API(yotpo);
              api.refreshWidgets();
              this.resetPrice()
              console.log(444040, '=> Yes here')
              redeemButtonView();
            } else if(!hasLoadingButton && this.gridLoad) {
              this.gridLoad.innerHTML = '';
              var api = new Yotpo.API(yotpo);
              api.refreshWidgets();
              this.resetPrice()
              console.log(444040, '=> Yes here')
              redeemButtonView();
            }
          })
          .catch(err => console.error(err));
      });
    }

    resetPrice() {
      $('.collection .grid__inner .grid__inner-item').each(function(e){
        var variantid = parseInt($(this).attr('data-attr-id'))
        var productHandle = $(this).attr('data-attr-handle');
        var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
        fetch(APIBASEURL+"/api/v1/MarketplaceItem/GetUserCircleDiscountList?id="+customerCircleId+"&variant_id="+variantid+"&poi_code="+poicode, requestOptions)
         .then(response => response.json()).then(result => {
               
               var len = result.length;
               if(len == 0){
                 $('.collection .grid__inner.js-grid-inner .grid__inner-item .product-api_price').css('display','flex');
                 return false;
               }
               result.forEach((elm,index) => {
               if(index == 0){
               var circle_id = elm.circleid;
               var shopify_handle = elm.shopify_handle;
               var redeem_points = elm.redeem_points;
               var discountvalue = elm.discountvalue;
               var product_discounted_price = elm.product_discounted_price;
                 product_discounted_price = product_discounted_price.toFixed(2);
               var product_actual_price = elm.product_actual_price;
                 product_actual_price = product_actual_price.toFixed(2);
               var pointsAuq = elm.acquired_points;
               var discountpct = elm.discountpct;
               var redeemPoints = elm.redemption_points;
               var strikethroughprice = elm.strikethroughprice;
               var strikethrough_redeem_points = elm.strikethrough_redeem_points;
               var dataAttr = '';
               var strickHtml = '';
               var rstrickHtml = '';
               var className = "";
               var discountClass = '';
                
               if(discountvalue > 0){
               dataAttr = `data-customprice="${product_discounted_price * 100}"`;
                  
               $('[data-submit]').attr('data-custom',product_discounted_price * 100);

                 
                 strickHtml = `<span class="initial-price compare_price_active">$${product_actual_price}</span>`;
                  if (product_actual_price == null || product_actual_price === 0) {
                    strickHtml = "N/A"; // Set a default value when the price is nil or 0
                  } else {
                    strickHtml = `<span class="initial-price compare_price_active">$${product_actual_price}</span>`;
                  }
                 discountClass = 'discountClass';
               }
               if(pointsAuq > 0){
               $('[data-submit]').attr('data-custompoints',pointsAuq);
               }
                
               // if(strikethroughprice){
               // strickHtml = `<span class="initial-price">$${product_actual_price}</span>`;
               // }
                     if(strikethrough_redeem_points){
                       rstrickHtml = `<span class="final-points">${product_actual_price} pts</span>`;
                     }
                  var html = `<div class="product-price check ${className}">
                    
                    <div class="price-container">
                      ${strickHtml}
                      <span class="final-price" ${dataAttr}>$${product_discounted_price}</span>                 
                    </div>
                  </div>
                  <span class="or_text">or</span>
                  <div class="product-pts">
                    <div class="redemption-price-container">
                    <span class="final-discount-points">${redeemPoints} points</span>
                    ${rstrickHtml}
                    </div>
                    <span class="discount-point ${discountClass}">${discountpct}%</span>
                  </div>`;

                 if (strickHtml === "") {
                        $('.collection .grid__inner.js-grid-inner .grid__inner-item[data-attr-handle="'+elm.shopify_handle+'"] .product-api_price, .collection .grid__inner.js-grid-inner .grid__inner-item[data-attr-id="'+elm.update_product_id+'"] .product-api_price').addClass('no__discount');
                 
                    } else {
                              $('.collection .grid__inner.js-grid-inner .grid__inner-item .product-api_price').addClass('show-points');
                      $('.collection .grid__inner.js-grid-inner .grid__inner-item[data-attr-handle="'+elm.shopify_handle+'"] .product-api_price, .collection .grid__inner.js-grid-inner .grid__inner-item[data-attr-id="'+elm.update_product_id+'"] .product-api_price').html(html);
                 
                    }
               }
            
                  if(index == len - 1){
                    $('.collection .grid__inner.js-grid-inner .grid__inner-item .product-api_price').css('display','flex');
                  }
              })
          }).catch(error => console.log('error', error));   
      })
      const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let circleid = urlParams.get('circleid');
        
        var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
        
        if(circleid == null){
          circleid = customerCircleId;
        }
        $('.collection .grid__inner .grid__inner-item').each(function(e){
          var variantid = $(this).find('.product-item__button').attr('data-variant-id')
          var selector = $(this).find('.product-item__button');
          fetch(APIBASEURL+"/api/v1/MarketplaceItem/GetUserCircleDiscountList?id="+circleid+"&variant_id="+variantid, requestOptions)
           .then(response => response.json()).then(result => {
           
           var len = result.length;
           if(len == 0){
             return false;
           }else{
           result.forEach((elm,index) => {
             console.log('ResultObj => ',elm)
             if(index == 0){
               selector.attr('data-maxlimit', elm.quantitylimit)
               redeemButtonView();
             }
          })
          }
      }).catch(error => console.log('error', error));   
        })
    }

    /**
     * resetLoadMoreButton - Reset the loading bar - load more button
     */

    resetLoadMoreButton() {
      this.gridLoad.dataset.currentPage = 1;
    }

    /**
     * shrink - Reduces the width of the grid to make room for the filters and adds minHeight in case the grid is too small to fit the filterBody element. Opposite of {@link expand}
     *
     * @param {Element} filterBody - CollectionFilters.body element
     */

    shrink(filterBody) {
      if(!this.filters) return this.gridInner.style.maxWidth = 'auto';
      this.gridInner.style.maxWidth = `${(this.clientWidth - 271) / 10}rem`;
      // this.gridInner.style.minHeight = `${(filterBody.scrollHeight) / 10}rem`;
    }

    /**
     * calculateHeight - Changes the minimum height of the grid
     *
     * @param {Number} height - The ammount that should be added or removed from the grid's height.
     * @param {Boolean} expand - True: increases the height of the grid, False: reduces the height of the grid
     */

    calculateHeight(height, expand) {
      if(window.innerWidth < 989) return this.gridInner.style.minHeight = 'initial';

      const currentHeight = this.gridInner.style.minHeight != 'auto' ? this.gridInner.style.minHeight.replace('rem', '').trim() * 10 : this.gridInner.scrollHeight;
      let newHeight = expand ? currentHeight + height : currentHeight - height;
      this.gridInner.style.minHeight = `${newHeight/10}rem`;
    }

    /**
     * expand - Expands the grid's width and sets the minHeight to auto. The opposite of {@link shrink}
     */

    expand() {
      this.gridInner.style.maxWidth = `${(this.clientWidth) / 10}rem`;
      this.gridInner.style.minHeight = `auto`;
    }

    /**
     * applySort - Sets the sort_by parameter in history and calls the {@link update} method
     *
     * @param {String} value - The sort <select> value
     */

    applySort(value) {
      const searchParams = new URLSearchParams(window.location.search.replace('?', ''));

      searchParams.set('sort_by', value);
      window.history.pushState({}, '', `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`);
      this.loadMoreButton = this.querySelector('.reedem-collection');
      if(this.loadMoreButton){
        searchParams.set('view', 'rajax-all-products');
        // params.set('view', 'rajax-all-products');
      }else{
        searchParams.set('view', this.view);
        // params.set('view', 'ajax-all-products');
      }
      
      // searchParams.set('view', this.view);

      this.resetLoadMoreButton();

      console.log(444040, '=> Yes here')
        redeemButtonView();

      this.update(`${window.location.origin}${window.location.pathname}?${searchParams.toString()}`);
    }

    /**
     * applyFilter - Add / remove a filter parameter based on the key, value and calls {@link update}
     *
     * @param {String} value - The filter value
     * @param {Boolean} checked - True: Add, False: Remove
     * @param {String} key - The filter key
     */

    applyFilter(value, checked, key) {
      const searchParams = new URLSearchParams(window.location.search.replace('?', ''));
      const currentValue = searchParams.get(`filter.v.m.custom.${key}`) ?? '';
      let newValue = currentValue;
      var filterValue = '';
      var pathName = window.location.pathname;
      this.resetPrice()
      if(value.indexOf('rooll_') > -1){
        if(pathName.indexOf('rooll_') > -1){
          filterValue = value; 
          if(checked){
            pathName = pathName+'+'+filterValue;
          }else{
            if(pathName.indexOf('+'+filterValue) > -1){
              pathName = pathName.replace('+'+filterValue,'');
            }else{
              pathName = pathName.replace(filterValue,'');
            }
          }
        }else{
          filterValue = '/'+value; 
          pathName = pathName+filterValue;
        }
      }else{

        // If the input is checked adds the filter to the newValue, or removes it from the newValue if unchecked
        if(checked) {
          newValue = newValue != '' ? newValue + ',' + value : value;
        } else {
          newValue = newValue.replace(value, '');
          if(newValue[newValue.length - 1] === ',') newValue = newValue.substring(0, newValue.length - 1);
        }
  
        // Setting the new value of the filter to newValue or removing it if the newValue is empty
        if(newValue != '') {
          searchParams.set(`filter.v.m.custom.${key}`, newValue);
        } else {
          searchParams.delete(`filter.v.m.custom.${key}`, `${currentValue}${value}`);
          this.filterBlocks.forEach(block => block.updateCounters());
        }

      }
      window.history.pushState({}, '', `${window.location.origin}${pathName}?${searchParams.toString()}`);
      this.loadMoreButton = this.querySelector('.reedem-collection');
      if(this.loadMoreButton){
        searchParams.set('view', 'rajax-all-products');
        // params.set('view', 'rajax-all-products');
      }else{
        searchParams.set('view', this.view);
        // params.set('view', 'ajax-all-products');
      }
      // searchParams.set('view', this.view);

      this.resetLoadMoreButton();

      console.log(444040, '=> Yes here')
      redeemButtonView();

      this.update(`${window.location.origin}${window.location.pathname}?${searchParams.toString().replace('%2C', ',')}`);
    }

    /**
     * applyMultiple - Clears all filters. Then applies only the currently checked input values and calls the {@link update} method.
     *
     * @param {NodeList} inputs - List of the currently active (checked) filter input elements
     */

    applyMultiple(inputs) {
      this.resetPrice()
      const searchParams = this.removeAll(false);

      inputs.forEach(input => {
        const currentValue = searchParams.get(`filter.v.m.custom.${input.dataset.key}`) ?? '';
        let newValue = currentValue != '' ? `${currentValue},${input.value}` : input.value;
        searchParams.set(`filter.v.m.custom.${input.dataset.key}`, newValue);
      });

      window.history.pushState({}, '', `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`);
      this.update(`${window.location.origin}${window.location.pathname}?${searchParams.toString()}`);

      if(this.activeFilters) this.activeFilters.update(inputs);
      console.log(444040, '=> Yes here')
      redeemButtonView();
    }

    /**
     * removeAll - Removes all currently active filters
     *
     * @param {Boolean} shouldUpdate - Should the new url be fetched. True by default
     */

    removeAll(shouldUpdate = true) {
      this.resetPrice()
      const searchParams = new URLSearchParams(window.location.search.replace('?', ''));
      const keysToRemove = [];

      // Deleting multiple search params inside the same iterator (forEach, entries) breaks it. Using keysToRemove instead
      searchParams.forEach((_value, key) => {
        if(key.includes('.custom.')) keysToRemove.push(key);
      });

      keysToRemove.forEach((key) => {
        searchParams.delete(key);
      });

      if(!shouldUpdate) return searchParams;

      var pathName = window.location.pathname;
      if(pathName.indexOf('rooll_') > -1){
        pathName = '/collections/redemption';
      }

      window.history.pushState({}, '', `${window.location.origin}${pathName}?${searchParams.toString()}`);
      this.update(`${window.location.origin}${window.location.pathname}?${searchParams.toString()}`);

      // Clearing the active-filters component
      const activeFilters = this.querySelector('active-filters');
      if(activeFilters) activeFilters.clearAll();

      // Unchecking all inputs
      const activeInputs = this.querySelectorAll('input');
      activeInputs.forEach(input => input.checked = false);

      // Removing selected text from filter-openers
      const selected = this.querySelectorAll('.js-current-filters-count');
      selected.forEach(span => {
        span.innerHTML = '';
        span.parentElement.classList.remove('has-selected');
      });
    }

    /**
     * update - Fetches the new product grid and loading bar
     *
     * @param {String} url
     */

    update(url) {
      fetch(url)
      .then(res => res.text())
      .then(data => {
        console.log("res",data)
        const html = new DOMParser().parseFromString(data, 'text/html');
        const gridInner = html.querySelector('.js-grid-inner');
        const gridLoad = html.querySelector('.js-grid-load');

        if(gridInner) this.gridInner.innerHTML = gridInner.innerHTML;
        this.gridLoad.innerHTML = gridLoad ? gridLoad.innerHTML : '';
        redeemButtonView();
        this.gridLoad.setAttribute('data-total-items', gridLoad.getAttribute('data-total-items'));
        this.setupLoadingBar();
        this.initLoadMoreButton();

        if(yotpo) yotpo.initWidgets();

        if(this.filters) this.filters.processInputs();
        this.resetPrice();
      })
      .catch(error => console.error(error));
    }

    
    /**
     * initResizeListener - Initializes the resize event listener for changing the grid width
     */

    initResizeListener() {
      this.filterBody = this.querySelector('.js-filter-body');

      window.addEventListener('resize', () => {
        this.gridWidth = this.gridInner?.clientWidth;
        if(this.filterBody) this.gridWidth += 271;
      });
    }

    connectedCallback() {
      this.expand();

      if(!this.gridLoad) return;
      this.setupLoadingBar();
      this.initLoadMoreButton();
      this.initResizeListener();
      this.resetPrice();
    }
  }

  customElements.define('collection-grid', CollectionGrid);
}
